// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_73-0";
export var optionCard = "_73-1";